import { FeatureCollection, Point } from 'geojson'
import RobotOnMapAsbis from 'images/for_map.robot_asbis.png'
import RobotOnMapAsbisWelder from 'images/for_map.robot_asbis_welder.png'
import RobotOnMapGs40 from 'images/for_map.robot_gs_40.png'
import RobotOnMapGs75 from 'images/for_map.robot_gs_75.png'
import RobotOnMapGsOmnie from 'images/for_map.robot_gs_omnie.png'
import RobotOnMapGsPhantas from 'images/for_map.robot_gs_phantas.png'
import RobotOnMapBlueComboOmni from 'images/robot_on_map_blue_combo_omni.png'
import RobotOnMapBlueSw from 'images/robot_on_map_blue_sw.png'
import RobotOnMapBlueSwsc from 'images/robot_on_map_blue_swsc.png'
import RobotOnMapComboOmniWhite from 'images/robot_on_map_combo_omni_white.png'
import RobotOnMapGreenComboOmni from 'images/robot_on_map_green_combo_omni.png'
import RobotOnMapGreenSw from 'images/robot_on_map_green_sw.png'
import RobotOnMapGreenSwsc from 'images/robot_on_map_green_swsc.png'
import RobotOnMapOrangeComboOmni from 'images/robot_on_map_orange_combo_omni.png'
import RobotOnMapOrangeSw from 'images/robot_on_map_orange_sw.png'
import RobotOnMapOrangeSwsc from 'images/robot_on_map_orange_swsc.png'
import RobotOnMapPinkComboOmni from 'images/robot_on_map_pink_combo_omni.png'
import RobotOnMapPinkSw from 'images/robot_on_map_pink_sw.png'
import RobotOnMapPinkSwsc from 'images/robot_on_map_pink_swsc.png'
import RobotOnMapPurpleComboOmni from 'images/robot_on_map_purple_combo_omni.png'
import RobotOnMapPurpleSw from 'images/robot_on_map_purple_sw.png'
import RobotOnMapPurpleSwsc from 'images/robot_on_map_purple_swsc.png'
import RobotOnMapWhite from 'images/robot_on_map_white.png'
import RobotOnMapYellowComboOmni from 'images/robot_on_map_yellow_combo_omni.png'
import RobotOnMapYellowSw from 'images/robot_on_map_yellow_sw.png'
import RobotOnMapYellowSwsc from 'images/robot_on_map_yellow_swsc.png'
import { VENDOR, VendorCode } from 'utils/vendorDisplayName'

/** All PNGs used as `icon-image` for robot symbol layers (Autonomics + Gausium + legacy names). */
export const ROBOT_MAP_IMAGES: Array<{ name: string; image: string }> = [
  { name: 'robot-blue-sw', image: RobotOnMapBlueSw },
  { name: 'robot-blue-swsc', image: RobotOnMapBlueSwsc },
  { name: 'robot-green-sw', image: RobotOnMapGreenSw },
  { name: 'robot-green-swsc', image: RobotOnMapGreenSwsc },
  { name: 'robot-pink-sw', image: RobotOnMapPinkSw },
  { name: 'robot-pink-swsc', image: RobotOnMapPinkSwsc },
  { name: 'robot-purple-sw', image: RobotOnMapPurpleSw },
  { name: 'robot-purple-swsc', image: RobotOnMapPurpleSwsc },
  { name: 'robot-yellow-sw', image: RobotOnMapYellowSw },
  { name: 'robot-yellow-swsc', image: RobotOnMapYellowSwsc },
  { name: 'robot-orange-sw', image: RobotOnMapOrangeSw },
  { name: 'robot-orange-swsc', image: RobotOnMapOrangeSwsc },
  { name: 'robot-blue-combo-omni', image: RobotOnMapBlueComboOmni },
  { name: 'robot-green-combo-omni', image: RobotOnMapGreenComboOmni },
  { name: 'robot-pink-combo-omni', image: RobotOnMapPinkComboOmni },
  { name: 'robot-purple-combo-omni', image: RobotOnMapPurpleComboOmni },
  { name: 'robot-yellow-combo-omni', image: RobotOnMapYellowComboOmni },
  { name: 'robot-orange-combo-omni', image: RobotOnMapOrangeComboOmni },
  { name: 'robot-combo-omni-white', image: RobotOnMapComboOmniWhite },
  { name: 'robot-white-sw', image: RobotOnMapWhite },
  { name: 'robot-white-swsc', image: RobotOnMapWhite },
  { name: 'robot-gs-40', image: RobotOnMapGs40 },
  { name: 'robot-gs-omnie', image: RobotOnMapGsOmnie },
  { name: 'robot-gs-75', image: RobotOnMapGs75 },
  { name: 'robot-gs-phantas', image: RobotOnMapGsPhantas },
  { name: 'robot-asbis', image: RobotOnMapAsbis },
  { name: 'robot-asbis-welder', image: RobotOnMapAsbisWelder },
  { name: 'robot-white', image: RobotOnMapWhite },
  { name: 'robot-blue', image: RobotOnMapBlueSwsc },
  { name: 'robot-green', image: RobotOnMapGreenSwsc },
  { name: 'robot-pink', image: RobotOnMapPinkSwsc },
  { name: 'robot-purple', image: RobotOnMapPurpleSwsc },
  { name: 'robot-yellow', image: RobotOnMapYellowSwsc },
  { name: 'robot-orange', image: RobotOnMapOrangeSwsc },
]

/**
 * Mapbox GL v3+: symbol layers may render before async loadImage finishes; the map then emits
 * `styleimagemissing`. Loading on this event fixes missing Autonomics/GS markers.
 */
export const registerRobotStyleImageMissingHandler = (map: mapboxgl.Map | undefined) => {
  if (!map) return () => {}
  const handler = (e: { id?: string }) => {
    const id = e?.id
    if (!id || !id.startsWith('robot-')) return
    const entry = ROBOT_MAP_IMAGES.find(x => x.name === id)
    if (!entry || map.hasImage(id)) return
    map.loadImage(entry.image, (error, img) => {
      if (error || !img) return
      if (!map.hasImage(id)) map.addImage(id, img)
    })
  }
  map.on('styleimagemissing', handler as never)
  return () => map.off('styleimagemissing', handler as never)
}

export const loadRobotImage = (map: mapboxgl.Map | undefined, imageName: string = 'robot') => {
  if (map?.hasImage(imageName)) {
    return
  }
  map?.loadImage(RobotOnMapPinkSwsc, (error, image) => {
    if (error || !image) {
      return
    }
    if (!map?.hasImage(imageName)) {
      map?.addImage(imageName, image)
    }
  })
}

export const loadAllRobotImages = (map: mapboxgl.Map | undefined) => {
  if (!map) return

  ROBOT_MAP_IMAGES.forEach(({ name, image }) => {
    if (map.hasImage(name)) return

    map.loadImage(image, (error, img) => {
      if (error || !img) return
      if (map.hasImage(name)) return
      map.addImage(name, img)
    })
  })
}

/**
 * Returns the icon name for a robot based on its color and type
 */
export const getRobotIconName = (vendor?: VendorCode | string, color?: string, type?: string): string => {
  if (vendor === VENDOR.ASBIS) {
    const asbisType = (type || '').toLowerCase().trim()
    if (asbisType === 'welder') return 'robot-asbis-welder'
    return 'robot-asbis'
  }

  if (vendor === VENDOR.GAUSIUM) {
    const gsType = (type || '').toString().trim()
    const gsTypeUpper = gsType.toUpperCase()

    // Canonical GS codes from backend mapping:
    // 75=Scrubber 75, 40=Vacuum 40, 50=Omnie, S=Phantas
    if (gsType === '75') return 'robot-gs-75'
    if (gsType === '40') return 'robot-gs-40'
    if (gsType === '50') return 'robot-gs-omnie'
    if (gsTypeUpper === 'S') return 'robot-gs-phantas'

    return 'robot-gs-75'
  }

  const robotType = type?.toLowerCase() || ''
  const isComboOmni = robotType === 'comboomni' || robotType === 'combo omni'
  const isSwsc = robotType === 'combo' || robotType.includes('scrub')

  if (isComboOmni) {
    if (color === 'White') {
      return 'robot-combo-omni-white'
    }

    switch (color) {
      case 'Blue':
        return 'robot-blue-combo-omni'
      case 'Green':
        return 'robot-green-combo-omni'
      case 'Yellow':
        return 'robot-yellow-combo-omni'
      case 'Orange':
        return 'robot-orange-combo-omni'
      case 'Purple':
        return 'robot-purple-combo-omni'
      case 'Pink':
      default:
        return 'robot-pink-combo-omni'
    }
  }

  // White robots only have one variant for now, based on images list
  if (color === 'White') {
    return 'robot-white'
  }

  const typeSuffix = isSwsc ? '-swsc' : '-sw'
  let iconColor = 'pink'

  switch (color) {
    case 'Blue':
      iconColor = 'blue'
      break
    case 'Green':
      iconColor = 'green'
      break
    case 'Yellow':
      iconColor = 'yellow'
      break
    case 'Orange':
      iconColor = 'orange'
      break
    case 'Purple':
      iconColor = 'purple'
      break
    case 'Pink':
    default:
      iconColor = 'pink'
  }

  return `robot-${iconColor}${typeSuffix}`
}

export const setMapCursor = (map: mapboxgl.Map | undefined, cursor: string) => {
  if (map) {
    map.getCanvas().style.cursor = cursor
  }
}

// Create arrow icon for rotation handle marker
export const createRotationArrowImage = (): HTMLImageElement | null => {
  try {
    const canvas = document.createElement('canvas')
    canvas.width = 64
    canvas.height = 64
    const ctx = canvas.getContext('2d')
    if (!ctx) return null

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height)

    // Draw circle with two arrows indicating rotation direction (clockwise)
    ctx.fillStyle = '#9747FF'
    ctx.strokeStyle = '#ffffff'
    ctx.lineWidth = 2.5

    const centerX = 32
    const centerY = 32
    const radius = 10
    const arrowDistance = 12 // Distance from circle center to arrowhead start
    const arrowHeadSize = 8 // Arrowhead size (comparable to circle radius)
    const arrowWidth = 4 // Arrowhead width

    // Draw circle
    ctx.beginPath()
    ctx.arc(centerX, centerY, radius, 0, Math.PI * 2)
    ctx.fill()
    ctx.stroke()

    // Function to draw only triangular arrowhead (without line)
    const drawArrow = (angle: number) => {
      // Arrowhead tip (farther from center)
      const tipX = centerX + Math.cos(angle) * (arrowDistance + arrowHeadSize)
      const tipY = centerY - Math.sin(angle) * (arrowDistance + arrowHeadSize)

      // Arrow direction vector (from center outward)
      const unitX = Math.cos(angle)
      const unitY = -Math.sin(angle)

      // Perpendicular vector for arrowhead width
      const perpX = -unitY
      const perpY = unitX

      // Triangle base (closer to center)
      const baseX = centerX + Math.cos(angle) * arrowDistance
      const baseY = centerY - Math.sin(angle) * arrowDistance

      // Triangle base points
      const basePoint1X = baseX + perpX * arrowWidth
      const basePoint1Y = baseY + perpY * arrowWidth
      const basePoint2X = baseX - perpX * arrowWidth
      const basePoint2Y = baseY - perpY * arrowWidth

      // Draw only triangular arrowhead with black outline
      ctx.strokeStyle = '#000000'
      ctx.lineWidth = 2
      ctx.fillStyle = '#ffffff'

      ctx.beginPath()
      ctx.moveTo(tipX, tipY) // Tip
      ctx.lineTo(basePoint1X, basePoint1Y) // Left base point
      ctx.lineTo(basePoint2X, basePoint2Y) // Right base point
      ctx.closePath()
      ctx.fill() // White fill
      ctx.stroke() // Black outline
    }

    // Draw first arrow (up, 0° or north)
    const angle1 = 0
    drawArrow(angle1)

    // Draw second arrow (down, 180° or south) - 180 degrees difference
    const angle2 = Math.PI
    drawArrow(angle2)

    // Convert canvas to image
    const img = new Image()
    img.src = canvas.toDataURL()
    return img
  } catch (error) {
    console.error('Error creating rotation arrow image', error)
    return null
  }
}

export const loadRotationHandleImage = (map: mapboxgl.Map | undefined) => {
  if (map?.hasImage('rotation-handle')) {
    return
  }
  const arrowImage = createRotationArrowImage()
  if (arrowImage) {
    arrowImage.onload = () => {
      if (!map?.hasImage('rotation-handle')) {
        map?.addImage('rotation-handle', arrowImage)
      }
    }
  }
}

export const createRobotPointData = (
  position: Point | undefined,
  yaw: number,
  icon?: string
): FeatureCollection<Point> => {
  if (!position) {
    return {
      type: 'FeatureCollection',
      features: [],
    }
  }
  return {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: position.coordinates,
        },
        properties: {
          yaw,
          icon,
        },
      },
    ],
  }
}
